import { createFileRoute } from '@tanstack/react-router'
import AdminOrganizationDetailPage from '@/components/pages/Admin/AdminOrganizationDetailPage/AdminOrganizationDetailPage'

export const Route = createFileRoute(
  '/$workspaceName/$environment/admin/organizations/$organizationId',
)({
  component: AdminOrganizationDetailRoute,
})

function AdminOrganizationDetailRoute() {
  return <AdminOrganizationDetailPage />
}
